import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation"
import Table from "../../components/Table/Table";
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import { context, } from '../../context/authContext';
import useApi from '../../helpers/api';
import Loader from "../../components/Loader/Loader";
import useColumns from './columns';
import useActions from './acciones';
import ConfirmModal from "../../components/Modal/Modal.js"


export default function Salas() {
  const [data, setData] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const { handleLogout, user } = useContext(context);
  const gridRef = useRef();
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const  columnDefs  = useColumns(setSelectedRow,setModalOpen,empresas);
  const { createHook, onCellEditingStopped, confirmDelete } = useActions(empresas);
  const api = useApi();

  const canCreate = useMemo(() => ({
    canCreate: Array.isArray(user?.rol) 
      ? user.rol.some(m => m.nombre === "Salas" && m.permiso.includes("crear")) 
      : false,
    button: "Crear sala"
  }), [user?.rol]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getSalas();
        if (response?.response?.data?.error) {
          handleLogout();
          return;
        }
        setData(response)
        const empresasApi = await api.getEmpresas();
        setEmpresas(empresasApi)
      } catch (err) {
        handleLogout();
      }
    };

    fetchData();  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout]);

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Salas" />
      {!!data ? 
        <Table 
        columns={columnDefs} 
        data={data}
        onCellEditingStopped={onCellEditingStopped}
        canCreate={canCreate}
        createHook={createHook}
        gridRef={gridRef}
        />
      :
        <Loader/>
      }
      <ConfirmModal
        isOpen={modalOpen}
        tipo= "confirmacion"
        message={`Are you sure you want to delete ${selectedRow?.data.nombre}?`}
        onConfirm={()=>confirmDelete(gridRef, selectedRow, setModalOpen, setSelectedRow)}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
}